import { Dispatch } from "react";
import { useTranslation } from "react-i18next";
import { Select, Stack, Title } from "@mantine/core";
import { Action } from "../../hooks/useSettings";
import { SpeechRate } from "../../api";
import { useSettings } from "../../SettingsContext";

export interface DeveloperSettingProps {
    onSettingsChange: Dispatch<Action>;
}

export const DeveloperSetting = ({ onSettingsChange }: DeveloperSettingProps) => {
    const { t } = useTranslation();
    const [settings] = useSettings();

    return (
        <Stack gap="sm">
            <Title order={4}>Speech Settings</Title> {/* <h1> */}
            <Select
                label={t("labels.speechRate.label")}
                description={t("helpTexts.speechRate")}
                defaultValue={settings.speechRate}
                data={[
                    {
                        label: t("labels.speechRate.options.xslow"),
                        value: "x-slow"
                    },
                    {
                        label: t("labels.speechRate.options.slow"),
                        value: "slow"
                    },
                    {
                        label: t("labels.speechRate.options.medium"),
                        value: "medium"
                    },
                    {
                        label: t("labels.speechRate.options.fast"),
                        value: "fast"
                    },
                    {
                        label: t("labels.speechRate.options.xfast"),
                        value: "x-fast"
                    }
                ]}
                onChange={ev => onSettingsChange({ type: "speechRate", value: ev as SpeechRate })}
            />
        </Stack>
    );
};
